import { useRef } from "react";
import Box from "../../../../components/Box";
import CustomNumberInput from "../../../../components/CustomNumberInput";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { Helpers } from "../../../../helpers/Helpers";
import { GetAntrepoByIdResponse } from "../../../../models/response/antrepo/GetAntrepoByIdResponse";
import { AntrepoService } from "../../../../services/AntrepoService";
import { ConstantService } from "../../../../services/ConstantService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import { GetConstantByIdResponse } from "../../../../models/response/constant/GetConstantByIdResponse";
import { useDispatch } from "react-redux";
import { storeActivityIndicator } from "../../../../redux/reducers/authSlice";

interface Props {
    generalInformationRef: any
    ledgerNo: string | undefined
    setLedgerNo: React.Dispatch<React.SetStateAction<string | undefined>>
    antrepoDeclarationNo: string | undefined
    setAntrepoDeclarationNo: React.Dispatch<React.SetStateAction<string | undefined>>
    antrepoDeclarationDate: string | undefined
    setAntrepoDeclarationDate: React.Dispatch<React.SetStateAction<string | undefined>>
    freeStorageRefNo: string | undefined
    setFreeStorageRefNo: React.Dispatch<React.SetStateAction<string | undefined>>
    goodsAmount: string | undefined
    setGoodsAmount: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedGoodsAmountCurrencyType: CustomSingleSelectModel | undefined
    setSelectedGoodsAmountCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    guaranteeAmount: string | undefined
    setGuaranteeAmount: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedGuaranteeAmountCurrencyType: CustomSingleSelectModel | undefined
    setSelectedGuaranteeAmountCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedSaleType: CustomSingleSelectModel | undefined
    setSelectedSaleType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedGuaranteeType: CustomSingleSelectModel | undefined
    setSelectedGuaranteeType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    declarationPotQuantity: string | undefined
    setDeclarationPotQuantity: React.Dispatch<React.SetStateAction<string | undefined>>
    declarationPotWeight: string | undefined
    setDeclarationPotWeight: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedCustomsDirectorate: CustomSingleSelectModel | undefined
    setSelectedCustomsDirectorate: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    generateDeclarationNo: (_selectedCustomsDirectorate: CustomSingleSelectModel | undefined) => void
    defaultAntrepoDeclarationNo: string
    selectedAntrepo: CustomSingleSelectModel | undefined
    setSelectedAntrepo: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    isDisabledFromLock: boolean
}

const GeneralInformation = ({
    generalInformationRef,
    ledgerNo,
    setLedgerNo,
    antrepoDeclarationNo,
    setAntrepoDeclarationNo,
    antrepoDeclarationDate,
    setAntrepoDeclarationDate,
    freeStorageRefNo,
    setFreeStorageRefNo,
    goodsAmount,
    setGoodsAmount,
    selectedGoodsAmountCurrencyType,
    setSelectedGoodsAmountCurrencyType,
    guaranteeAmount,
    selectedGuaranteeAmountCurrencyType,
    setGuaranteeAmount,
    setSelectedGuaranteeAmountCurrencyType,
    selectedSaleType,
    setSelectedSaleType,
    selectedGuaranteeType,
    setSelectedGuaranteeType,
    declarationPotQuantity,
    setDeclarationPotQuantity,
    declarationPotWeight,
    setDeclarationPotWeight,
    selectedCustomsDirectorate,
    setSelectedCustomsDirectorate,
    generateDeclarationNo,
    defaultAntrepoDeclarationNo,
    selectedAntrepo,
    setSelectedAntrepo,
    isDisabledFromLock
}: Props) => {
    const dispatch = useDispatch();
    const antrepoDeclarationNoRef: any = useRef();

    const onAntrepoChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        try {
            setSelectedAntrepo(selectedValue);

            if (selectedValue) {
                dispatch(storeActivityIndicator(true));

                var response6: GetAntrepoByIdResponse = await AntrepoService.getAntrepoById(selectedValue.value);

                if (!response6.isSuccess) {
                    toast.error(response6.message)
                    return;
                }

                if (response6.data) {
                    if (!Helpers.isEmpty(response6.data.baseAntrepoId)) {
                        var response7: GetConstantByIdResponse = await ConstantService.getConstantById(response6.data.baseAntrepoId + '');

                        if (!response7.isSuccess) {
                            toast.error(response6.message)
                            return;
                        }

                        if (response7.data && response7.data.parentConstantId) {
                            response7 = await ConstantService.getConstantById(response7.data.parentConstantId);

                            if (!response7.isSuccess) {
                                toast.error(response6.message)
                                return;
                            }

                            if (response7.data) {
                                setSelectedCustomsDirectorate({ label: response7.data.value, value: response7.data.constantId });
                                generateDeclarationNo({ label: response7.data.value, value: response7.data.constantId, additionalValue1: response7.data.additionalValue1 })
                            }
                        }
                    }
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <div className='containerPart' ref={generalInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <Box gap="20px" flexDirection="row">
                        <Box flex={1 / 3}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Defter No</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={ledgerNo} onChange={(e) => setLedgerNo(e.target.value)} type="text" className="form-control form-control-solid" disabled />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Gümrük Müdürlüğü</label>

                                <CustomSingleSelect
                                    selectedValue={selectedCustomsDirectorate}
                                    onChange={(selectedValue) => {
                                        setSelectedCustomsDirectorate(selectedValue)
                                        generateDeclarationNo(selectedValue);
                                        antrepoDeclarationNoRef.current.focus();
                                    }}
                                    onMenuOpen={() => ConstantService.getConstantList('ANTREPO')}
                                    labelName='value'
                                    valueName='constantId'
                                    additionalValue1Name="additionalValue1"
                                    disabled={isDisabledFromLock}
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Antrepo Beyan No</label>
                                <input disabled={!selectedCustomsDirectorate || isDisabledFromLock} ref={antrepoDeclarationNoRef} style={{ border: '1px solid #F1F1F4' }} value={antrepoDeclarationNo} onChange={(e) => setAntrepoDeclarationNo(e.target.value.startsWith(defaultAntrepoDeclarationNo) ? e.target.value : defaultAntrepoDeclarationNo)} type="text" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Antrepo Beyan Tarihi</label>
                                <input disabled={isDisabledFromLock} style={{ border: '1px solid #F1F1F4' }} value={Helpers.isEmpty(antrepoDeclarationDate) ? undefined : antrepoDeclarationDate?.split('T')[0].split(' ')[0]} onChange={(e) => setAntrepoDeclarationDate(e.target.value)} type="date" className="form-control form-control-solid" />
                            </div>
                        </Box>

                        <Box flex={1 / 3}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Beyan Kap Adet</label>
                                <CustomNumberInput isDisabled={isDisabledFromLock} value={declarationPotQuantity} setValue={setDeclarationPotQuantity} />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Beyan Kap Ağırlık (Kg)</label>
                                <CustomNumberInput isDisabled={isDisabledFromLock} value={declarationPotWeight} setValue={setDeclarationPotWeight} />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Mal Değeri</label>

                                <Box flexDirection="row">
                                    <Box mr="15px" flexGrow={1} justifyContent="center">
                                        <CustomNumberInput isDisabled={isDisabledFromLock} value={goodsAmount} setValue={setGoodsAmount} />
                                    </Box>
                                    <Box justifyContent="center">
                                        <CustomSingleSelect
                                            selectedValue={selectedGoodsAmountCurrencyType}
                                            onChange={setSelectedGoodsAmountCurrencyType}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                            labelName='additionalValue1'
                                            valueName='constantId'
                                            disabled={isDisabledFromLock}
                                        />
                                    </Box>
                                </Box>
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Teminat Bedeli</label>

                                <Box flexDirection="row">
                                    <Box mr="15px" flexGrow={1} justifyContent="center">
                                        <CustomNumberInput isDisabled={isDisabledFromLock} value={guaranteeAmount} setValue={setGuaranteeAmount} />
                                    </Box>
                                    <Box justifyContent="center">
                                        <CustomSingleSelect
                                            selectedValue={selectedGuaranteeAmountCurrencyType}
                                            onChange={setSelectedGuaranteeAmountCurrencyType}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                            labelName='additionalValue1'
                                            valueName='constantId'
                                            disabled={isDisabledFromLock}
                                        />
                                    </Box>
                                </Box>
                            </div>
                        </Box>

                        <Box flex={1 / 3}>
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Satış Şekli</label>
                                <CustomSingleSelect
                                    selectedValue={selectedSaleType}
                                    onChange={setSelectedSaleType}
                                    onMenuOpen={() => ConstantService.getConstantList('INCOTERM')}
                                    labelName='additionalValue1'
                                    valueName='constantId'
                                    label2Name="value"
                                    disabled={isDisabledFromLock}
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Antrepo</label>
                                <CustomSingleSelect
                                    selectedValue={selectedAntrepo}
                                    onChange={onAntrepoChange}
                                    onMenuOpen={() => AntrepoService.getAntrepoList()}
                                    labelName='baseAntrepoFullName'
                                    valueName='antrepoId'
                                    disabled={isDisabledFromLock}
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Teminat Türü</label>
                                <CustomSingleSelect
                                    selectedValue={selectedGuaranteeType}
                                    onChange={setSelectedGuaranteeType}
                                    onMenuOpen={() => ConstantService.getConstantList('GUARANTEE_TYPE')}
                                    labelName='value'
                                    valueName='constantId'
                                    additionalValue1Name="additionalValue1"
                                    disabled={isDisabledFromLock}
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Serbest Depo Ref No</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={freeStorageRefNo} onChange={(e) => setFreeStorageRefNo(e.target.value)} type="text" className="form-control form-control-solid" disabled />
                            </div>
                        </Box>
                    </Box>
                </KTCardBody>
            </KTCard>
        </div >
    )
}

export default GeneralInformation;